'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _find3 = require('lodash/find');

var _find4 = _interopRequireDefault(_find3);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Dropdown = require('react-bootstrap/lib/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCookie = require('react-cookie');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./LangSelector.scss');

var LangSelector = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isMobile: state.common.isMobile
  };
}), _dec(_class = (0, _reactCookie.withCookies)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LangSelector, _Component);

  function LangSelector() {
    (0, _classCallCheck3.default)(this, LangSelector);
    return (0, _possibleConstructorReturn3.default)(this, (LangSelector.__proto__ || (0, _getPrototypeOf2.default)(LangSelector)).apply(this, arguments));
  }

  (0, _createClass3.default)(LangSelector, [{
    key: 'changeLang',
    value: function changeLang(langCode) {
      this.props.cookies.set('i18next', langCode, { path: '/' });
      window.location.reload();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var langs = _config2.default.app.langs;
      var _context$i18n = this.context.i18n;
      _context$i18n = _context$i18n === undefined ? 'en' : _context$i18n;
      var language = _context$i18n.language;
      var _props = this.props,
          className = _props.className,
          isMobile = _props.isMobile;

      var currentLang = (0, _find4.default)(langs, { code: language });
      var getFlagImg = function getFlagImg(code) {
        return require('./flag-' + ((isMobile ? 'mobile-' : '') + code.toLowerCase()) + '.png');
      }; // eslint-disable-line import/no-dynamic-require

      return _react2.default.createElement(
        _ButtonToolbar2.default,
        { className: (0, _classnames2.default)(styles.langSelector, className), title: currentLang.name },
        _react2.default.createElement(
          _Dropdown2.default,
          { pullRight: true, id: 'lang-selector-dropdown' },
          _react2.default.createElement(
            _Dropdown2.default.Toggle,
            { className: (0, _classnames2.default)('btn-clear', styles.toggle), bsStyle: 'link' },
            _react2.default.createElement('img', { src: getFlagImg(currentLang.code), alt: '' })
          ),
          _react2.default.createElement(
            _Dropdown2.default.Menu,
            { title: '' },
            langs.map(function (lang) {
              return _react2.default.createElement(
                _MenuItem2.default,
                { key: lang.code, onClick: function onClick() {
                    return _this2.changeLang(lang.code);
                  } },
                _react2.default.createElement('img', { src: getFlagImg(lang.code), alt: '' }),
                lang.name
              );
            })
          )
        )
      );
    }
  }]);
  return LangSelector;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  cookies: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool
}, _class2.contextTypes = {
  i18n: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class);
exports.default = LangSelector;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LangSelector/LangSelector.js
// module id = 2028
// module chunks = 1